import { ChevronDown } from "lucide-react";

export const ChannelStory = ({ story, testId }) => {
  if (!story) return null;
  return (
    <div className="mt-4 flex flex-col lg:flex-row lg:items-end gap-4 lg:gap-8" data-testid={testId}>
      <p className="flex-1 text-slate-100 text-base md:text-lg leading-relaxed">{story.sentence}</p>
      {story.stats?.length > 0 && (
        <div className="flex gap-3 shrink-0">
          {story.stats.map(([label, value]) => (
            <div key={label} className="rounded-xl bg-white/[0.06] ring-1 ring-white/10 px-4 py-2.5 min-w-[110px]">
              <p className="text-white text-xl md:text-2xl font-black tabular-nums leading-none">{value}</p>
              <p className="text-slate-400 text-[11px] mt-1">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const SeeNumbersHint = ({ open, className = "text-slate-300" }) => (
  <span className={`mt-3 inline-flex items-center gap-1 text-xs font-semibold opacity-80 group-hover:opacity-100 transition-opacity ${className}`}>
    {open ? "Hide the numbers" : "See the numbers"}
    <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
  </span>
);
